//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// chrome-nav imports
import { IProps, IState, IContainer } from "./ChromeNav.d";
import {
  ChromeNavCalendarProfile,
  ChromeNavEvent,
  ChromeNavHome,
  ChromeNavCreateEvent,
  ChromeNavEventScheduler,
  ChromeNavAutopilotList,
  ChromeNavTeamDashboard,
} from "./nav-content";
import * as s from "./ChromeNav.styles";
// other components
import { FastCrawlLoader } from "@components/fast-crawl-loader";
import { IReduxState } from "@reducers/root.reducer";
// util
import { ChromeAppWrapperView } from "@util/chrome-extension.util";

//////////////////
// COMPONENT
//////////////////
class ChromeNavCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hovered: false,
    };
  }

  private onHover = (hovered: boolean) => {
    this.setState({ hovered });
  };

  private hasBottomBorder = (view: ChromeAppWrapperView) => {
    switch (view) {
      case ChromeAppWrapperView.GoogleContactSharingDisabled:
      case ChromeAppWrapperView.GoogleApiAccessDisabled:
      case ChromeAppWrapperView.ShouldCrawl:
      case ChromeAppWrapperView.NoCrawl:
      case ChromeAppWrapperView.NoAuth:
      case ChromeAppWrapperView.Onboarding:
      case ChromeAppWrapperView.TeamHealth:
      case ChromeAppWrapperView.Feed:
      case ChromeAppWrapperView.Day:
      case ChromeAppWrapperView.CalendarProfile:
      case ChromeAppWrapperView.AutopilotList:
        return true;
      default:
        return false;
    }
  };

  private getContent = () => {
    const { org, environment, authed, previousView, defaultView, onboardingFinished } = this.props;

    const { view } = this.props;

    const showMenu =
      authed &&
      onboardingFinished &&
      view !== ChromeAppWrapperView.PersonalCalendar &&
      view !== ChromeAppWrapperView.CalendarMismatch;

    const showTabs =
      authed &&
      onboardingFinished &&
      view !== ChromeAppWrapperView.PersonalCalendar &&
      view !== ChromeAppWrapperView.CalendarMismatch;

    if (!showTabs && view === ChromeAppWrapperView.TeamHealth) {
      return <ChromeNavTeamDashboard defaultView={defaultView} />;
    }

    switch (view) {
      case ChromeAppWrapperView.CalendarProfile:
        return <ChromeNavCalendarProfile org={org} environment={environment} />;
      case ChromeAppWrapperView.CreateEvent:
        return <ChromeNavCreateEvent />;
      case ChromeAppWrapperView.Event:
        return (
          <ChromeNavEvent
            orgId={org?.id || null}
            defaultView={defaultView}
            previousView={previousView}
          />
        );
      case ChromeAppWrapperView.EventScheduler:
        return <ChromeNavEventScheduler defaultView={defaultView} />;
      case ChromeAppWrapperView.AutopilotList:
        return <ChromeNavAutopilotList defaultView={defaultView} />;
      case ChromeAppWrapperView.CalendarMismatch:
      case ChromeAppWrapperView.TeamHealth:
      case ChromeAppWrapperView.Feed:
      case ChromeAppWrapperView.Onboarding:
      case ChromeAppWrapperView.NoAuth:
      case ChromeAppWrapperView.NoOrg:
      case ChromeAppWrapperView.PersonalCalendar:
      case ChromeAppWrapperView.GoogleContactSharingDisabled:
      case ChromeAppWrapperView.GoogleApiAccessDisabled:
      case ChromeAppWrapperView.NoCrawl:
      case ChromeAppWrapperView.ShouldCrawl:
      default:
        return (
          <ChromeNavHome
            showMenu={showMenu}
            showTabs={showTabs}
            showCollapse={this.state.hovered && this.props.mode === "extension"}
            environment={environment}
            org={org}
            showLogo
          />
        );
    }
  };

  private maybeRenderFastCrawlLoader = () => {
    const { view, authed, environment, fastCrawlFinished, onboardingFinished } = this.props;
    if (
      !authed ||
      fastCrawlFinished ||
      !onboardingFinished ||
      view === ChromeAppWrapperView.CalendarMismatch ||
      view === ChromeAppWrapperView.GoogleContactSharingDisabled ||
      view === ChromeAppWrapperView.GoogleApiAccessDisabled ||
      view === ChromeAppWrapperView.NoCrawl ||
      view === ChromeAppWrapperView.ShouldCrawl
    ) {
      return null;
    }

    return <FastCrawlLoader environment={environment} />;
  };

  public render() {
    const hasBottomBorder = this.hasBottomBorder(this.props.view);
    return (
      <div
        style={hasBottomBorder ? s.containerWithBorder : s.container}
        onMouseEnter={() => this.onHover(true)}
        onMouseLeave={() => this.onHover(false)}
      >
        {this.getContent()}
        {this.maybeRenderFastCrawlLoader()}
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    onboardingFinished: state.onboarding.onboardingFinished,
    fastCrawlFinished: state.onboarding.fastCrawlFinished,
    mode: state.webExtension.mode,
  };
}

export const ChromeNav = connect(mapStateToProps, {})(ChromeNavCmpt);
